export default {
  http_errors: {
    400: 'Coś poszło nie tak... spróbuj ponownie za jakiś czas!',
    401: 'Brak uprawnień!',
    403: 'Nie masz uprawnień do tego zasobu lub Twoja sesja wygasła!',
    404: 'Coś poszło nie tak... spróbuj ponownie za jakiś czas!',
    406: 'Nieprawidłowe dane.',
    429: 'Za dużo prób. Prosimy spróbować ponownie za chwilę',
    500: 'Chwilowy problem z przekieowaniem. Spróbuj za chwilę jeszcze raz.',
    503: 'Błąd serwera. Prosimy spróbować ponownie',
    504: 'Przekroczono czas oczekiwania, proszę spróbować jeszcze raz',
    422: 'Użytkownik nie ma przypisanych żadnych Klientów.',
  },
  header: {
    language: 'Język',
  },
};
